import anchorGo from './anchorGo.vue'
export default anchorGo
